import { PicTimeAdapter } from '~/apps/main/PicTime/pic-time.adapter';

export class PicTimeService extends PicTimeAdapter {}
